import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88889bc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-title" }, "请尽快完成考前环境检测", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "去检测", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.loginService.goToEnvCheckDialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginService.goToEnvCheckDialogVisible) = $event)),
    closable: true,
    "mask-closable": false,
    width: 432,
    header: null,
    footer: null,
    title: null,
    class: "env-check-dialog show-shadow"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_button, {
          type: "primary",
          shape: "round",
          size: "large",
          onClick: _ctx.goToEnvCheck,
          style: {"margin":"50px","width":"200px"}
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_CaretRightOutlined)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}